import { GetUsageReportFilter, UsageReport2Filter, UsageReport, UsageReport2 } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import {
  singleSortQueryFromPaginatedRequestParams,
  UsageReport2RequestParams,
  UsageReportRequestParams,
} from '../nm-types'

const bigintStringRegex = /^bigint\((-?\d+)\)$/

function convertBigIntStringsToNumbers(obj: unknown): unknown {
  if (obj === null || obj === undefined || obj instanceof Date) return obj
  if (typeof obj === 'string') {
    const m = bigintStringRegex.exec(obj)
    return m ? Number(m[1]) : obj
  }
  if (Array.isArray(obj)) return obj.map(convertBigIntStringsToNumbers)
  if (typeof obj === 'object') {
    const result: Record<string, unknown> = {}
    for (const [key, value] of Object.entries(obj)) {
      result[key] = convertBigIntStringsToNumbers(value)
    }
    return result
  }
  return obj
}

export class UsageApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  readUsage({ startDate, endDate, type, format, ...params }: UsageReportRequestParams): Promise<UsageReport> {
    const filter: GetUsageReportFilter = {
      startDate,
      endDate,
      type,
      format,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    return this.edgeClient.getUsageReport(query)
  }
  async readUsage2({
    startDate,
    endDate,
    format,
    serviceType: serviceTypeString,
    groupId,
    ...params
  }: UsageReport2RequestParams): Promise<UsageReport2> {
    const serviceType = serviceTypeString as UsageReport2Filter['serviceType'] | undefined
    const filter: UsageReport2Filter = {
      startDate,
      endDate,
      serviceType,
      groupId,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    const result = await this.edgeClient.getUsage(query)
    return convertBigIntStringsToNumbers(result) as UsageReport2
  }
}
